import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { switchMap, takeWhile } from 'rxjs/operators';
import { of } from 'rxjs';
import { Person } from '../../../../persons/models/person.model';
import { ShippingService } from '../../../services/shipping.service';

@Component({
  selector: 'app-person-info-modal',
  templateUrl: './person-info-modal.component.html',
  styleUrls: ['./person-info-modal.component.scss'],
  standalone: false
})
export class PersonInfoModalComponent implements OnInit, OnDestroy {

  public componentActive = true;
  public person: Person;

  public isLoadingShipments = false;
  public hasShipments: boolean;
  public shipmentsCheckFailed = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { person: Person },
    private shippingService: ShippingService
  ) {
    this.person = data.person;
  }

  ngOnInit() {
    this.checkShipments();
  }

  ngOnDestroy() {
    this.componentActive = false;
  }

  /**
   * Looks up the person's shipping clientId, then checks whether they have any shipments.
   */
  public checkShipments() {
    this.isLoadingShipments = true;
    this.shipmentsCheckFailed = false;

    this.shippingService.getShippingUserData(this.person.id)
      .pipe(
        takeWhile(() => this.componentActive),
        switchMap(shippingUserData => {
          const clientId = shippingUserData?.clientSetting?.clientId;
          return clientId ? this.shippingService.checkShipmentsExist(clientId) : of(null);
        })
      )
      .subscribe(
        hasShipments => {
          this.isLoadingShipments = false;
          this.hasShipments = hasShipments === null ? false : hasShipments;
        },
        () => {
          this.isLoadingShipments = false;
          this.shipmentsCheckFailed = true;
        }
      );
  }

}
